import { getBirthDateString, sanitizeText } from "../utils/index.js";
import { getAddressesFromInput } from "../utils/getAddressesFromInput.js";
import { CustomerType } from "../constants.js";
import { ensurePhoneExternalReference } from "../utils/ensurePhoneExternalReference.js";
const privateCustomerParent = {
    identifier: "privatkunder",
    type: "customerGroup",
};
export const selectCreateCustomerInput = (customerInput) => {
    const { phone, firstName, lastName, birthDate, email, addresses, externalReferences, meta, ...customer } = customerInput;
    return {
        ...customer,
        birthDate: birthDate ? getBirthDateString(birthDate) : undefined,
        identifier: crypto.randomUUID(),
        phone: phone ? sanitizeText(phone) : undefined,
        firstName: sanitizeText(firstName),
        lastName: sanitizeText(lastName),
        addresses: getAddressesFromInput(addresses, email ?? undefined),
        email: email ? sanitizeText(email) : undefined,
        parents: customerInput.type === CustomerType.INDIVIDUAL
            ? [privateCustomerParent]
            : undefined,
        // Fallback: ensure "phone" is always present in externalReferences, in case it was not included earlier in the customer object.
        externalReferences: ensurePhoneExternalReference(externalReferences, phone),
        meta: meta?.filter((meta) => meta?.key && meta?.value) ?? [],
    };
};
